import * as React from "react";
import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { IconButton } from "components/common";
import { FileListContainer, ListHeader, ListBody, FileListItem, FileName, DragMessage } from "../styled-components";
import { ACCEPTED_FILE_TYPES, getFilesWithOptions, useRuleSchemaValidation, hasError } from "../utils";
function FileList({ files, setFiles, selectedFile, setSelectedFile }) {
  const { validateRuleSchemas } = useRuleSchemaValidation();
  const onDrop = useCallback(
    (acceptedFiles) => {
      const auxAcceptedFiles = acceptedFiles.map((file) => {
        if (!file.type) {
          const extension = file.name.split(".").pop();
          const type = Object.keys(ACCEPTED_FILE_TYPES).find(
            (key) => ACCEPTED_FILE_TYPES[key].includes(`.${extension}`)
          );
          return new File([file], file.name, { type });
        }
        return file;
      });
      const newFiles = getFilesWithOptions(auxAcceptedFiles);
      validateRuleSchemas(newFiles).then((validatedFiles) => {
        const filesToAdd = validatedFiles.filter(
          (newFileForm) => !files.find(
            (fileForm) => fileForm.file.name === newFileForm.file.name && fileForm.file.size === newFileForm.file.size
          )
        );
        if (!selectedFile) setSelectedFile(filesToAdd[0]);
        setFiles(filesToAdd);
      });
    },
    [files, setFiles, validateRuleSchemas, selectedFile, setSelectedFile]
  );
  const { getRootProps, getInputProps, isDragActive, isFileDialogActive, open } = useDropzone({
    accept: Object.values(ACCEPTED_FILE_TYPES).flat().join(","),
    noClick: true,
    onDrop
  });
  const onSelectFile = useCallback(
    (inFileForm) => {
      setSelectedFile(void 0);
      setTimeout(() => setSelectedFile(inFileForm), 50);
    },
    [setSelectedFile]
  );
  const onRemoveFile = useCallback(
    (inFileId) => {
      setFiles(files.filter((file) => file.id !== inFileId));
    },
    [files, setFiles]
  );
  return /* @__PURE__ */ React.createElement(FileListContainer, null, /* @__PURE__ */ React.createElement(ListHeader, null, "Selected Files ", /* @__PURE__ */ React.createElement(IconButton, { name: "add", title: "Add rules", onClick: open })), /* @__PURE__ */ React.createElement(ListBody, { ...getRootProps({ style: { cursor: "default" } }), $isDragActive: isDragActive || isFileDialogActive }, files.map((fileForm) => /* @__PURE__ */ React.createElement(
    FileListItem,
    {
      key: fileForm.id,
      role: "listitem",
      onClick: (e) => e.stopPropagation(),
      $active: fileForm.id === (selectedFile == null ? void 0 : selectedFile.id)
    },
    /* @__PURE__ */ React.createElement(IconButton, { name: "close", title: "Remove file", onClick: () => onRemoveFile(fileForm.id), size: "sm" }),
    /* @__PURE__ */ React.createElement(
      FileName,
      {
        role: "link",
        title: "File name",
        $withError: hasError(fileForm),
        onClick: () => onSelectFile(fileForm)
      },
      fileForm.file.name
    )
  )), /* @__PURE__ */ React.createElement("input", { ...getInputProps({ id: "ruleFiles", "aria-label": "Drop zone" }) }), files.length < 1 && /* @__PURE__ */ React.createElement(DragMessage, null, "Drag 'n' Drop your rules here")));
}
export default FileList;
